const listNamesConfig = {
  entityItemsNamePlural: "Live Streams",
  entityItemName: "Live Stream",
  areaAccessName: "Playlists"
  // TODO: to change later to LiveStreams when areaAccessName is handled well in BSPortal.
  //    Also think about usage of feature flags to handle this
};

export default listNamesConfig;